/* eslint-disable max-len */
import React from 'react';
import color_classes from 'src/stylesheets/color_classes.module.scss';
import IconInterface from './IconInterface';

function IconDownChevron({
    fillColor = 'fillBlack',
    width = 10,
    height = 10,
}: IconInterface) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                className={color_classes[fillColor]}
                d="M9.70711 2.40117C10.0676 2.74724 10.0953 3.29178 9.7903 3.66838L9.70711 3.75882L5.70711 7.59882C5.34662 7.94488 4.77939 7.9715 4.3871 7.67868L4.29289 7.59882L0.292893 3.75882C-0.0976305 3.38391 -0.0976305 2.77608 0.292893 2.40117C0.653378 2.05511 1.22061 2.02849 1.6129 2.32131L1.70711 2.40117L5 5.5616L8.29289 2.40117C8.65338 2.05511 9.22061 2.02849 9.6129 2.32131L9.70711 2.40117Z"
                fill="white"
            />
        </svg>
    );
}

export default IconDownChevron;
